import { FactoryProvider, inject } from '@angular/core';
import { UserStore } from '@lib/user/data-access';
import { SPR_DATEPICKER_VALUE_FORMATTER } from '@platform-workspace/design-system';
import { DATE_FNS_FORMAT } from '@shared/utils/constants';
import { getDate, getMonth, getYear, parse } from 'date-fns';

export const provideDatePickerValueFormatter = (): FactoryProvider => {
  return {
    provide: SPR_DATEPICKER_VALUE_FORMATTER,
    useFactory: (): { format: (value: string | null) => string } => {
      const userStore = inject(UserStore);

      return {
        format: (value: string | null): string => {
          if (!value) {
            return '';
          }
          const parsedDate = parse(value, DATE_FNS_FORMAT[userStore.dateFormat()!], new Date());
          return new Date(Date.UTC(getYear(parsedDate), getMonth(parsedDate), getDate(parsedDate))).toISOString();
        },
      };
    },
  };
};
